<twc-popup caption="{{'MAIN_NOTIFICATION.TITLE' | translate}}" type="primary" [closable]="false" width="xl">
    <twc-popup-content *ngIf="message">
        {{ message }}
    </twc-popup-content>
    <twc-popup-footer>
        <button (click)="close()" class="twc-button twc-button-primary">{{'GENERAL.OK' | translate}}</button>
    </twc-popup-footer>
</twc-popup>